// Android app: which Google Play link-out program (if any) lets this user open our Stripe pages.
//   "eligible"     external content links (US; native ExternalContentLinkPlugin), checked first
//   "eligible_eu"  external offers (EEA; native ExternalOfferPlugin), checked only if not "eligible"
//   "ineligible"   neither: no purchase path, only the informational fallback
// Play decides region and enrollment; anything but a clear yes (plugin missing in an older app
// build, an error, no answer in time) counts as no.

export const ANDROID_LINK_CHANNELS = {
  eligible: "android_external_link",
  eligible_eu: "android_eu_external_offer",
};

// checks: { us: { available, check }, eu: { available, check } }, where check() resolves to the
// plugin's { eligible } answer. withTimeout(promise) bounds each native call.
export async function resolveAndroidLinkStatus(checks, withTimeout) {
  const ask = async ({ available, check }) => {
    if (!available) return false;
    try {
      const result = await withTimeout(check());
      return result?.eligible === true;
    } catch (e) {
      return false;
    }
  };
  if (await ask(checks.us)) return "eligible";
  if (await ask(checks.eu)) return "eligible_eu";
  return "ineligible";
}

// The checkout channel for a status, or undefined (no tag) when there's no Android program.
export function androidLinkChannel(status) {
  return ANDROID_LINK_CHANNELS[status];
}
